import React, { Component } from 'react';
import App from '../../App';
import { withApollo } from 'react-apollo';
import { Table,Button,Icon } from 'antd';
import getUserWalletTransactions from '../../queries/getUserWalletTransactions'
import getUserWalletBalance from '../../queries/getUserWalletBalance'
import {returnSymbol} from '../../utils/returnSymbol'
import moment from 'moment'

class CPWallet extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            transactions: [],
            wallet: null
        }
    }
    componentDidMount() {
        this.getWalletBalance()
        this.setState({ loading: true });
        this.props.client.query({
            query: getUserWalletTransactions,
            variables: {
                userId: this.props.userData.username,
            },
            fetchPolicy: 'network-only',
        }).then(({ data }) => {
            console.log("data", data)
            this.setState({
                transactions: data.getUserWalletTransactions,
                loading: false
            })
        }).catch((error) => {
            console.error('Error fetching data:', error);
            this.setState({ loading: false });
        });
    }
    getWalletBalance=()=>{
        this.props.client.query({
            query: getUserWalletBalance,
            variables: {
                userId: this.props.userData.username,
            },
            fetchPolicy: 'network-only',
        }).then(({ data }) => {
            console.log("data", data)
            this.setState({
                wallet: data.getUserWalletBalance,
                loading: false
            })
        }).catch((error) => {
            console.error('Error fetching data:', error);
            this.setState({ loading: false });
        });
    }
    render() {
        // console.log("this.props",this.props)
         const columns=[
                    {
                        title: 'Date',
                        dataIndex:'createdAt',
                        width: '15%',
                        render: (data) => {
                            var dateString = moment.unix(data).format("DD/MM/YYYY HH:mm");
                            return (
                                <span>{dateString}</span>
                            )
                        }
                    },
                    {
                        title: 'Type',
                        dataIndex: 'transactionType',
                        width: '10%',
                    },
                    {
                        title: 'Transaction Amount',
                        // dataIndex: 'amount',
                        width: '15%',
                        render:(data)=>{
                            return(
                                <span>{returnSymbol(data.amount/100,data.currency ? data.currency : 'INR')}</span>
                            )
                        }
                    },
                    {
                        title: 'Balance',
                        dataIndex: 'balance',
                        width: '10%',
                        render:(data)=>{
                            return(
                                <span>{returnSymbol(data/100,data.currency ? data.currency : 'INR')}</span>
                            )
                        }
                    },
                    {
                        title: 'Note',
                        dataIndex: 'note',
                        width: '20%',
                    },
                ]
        return (
            <App>
                <p style={{ textAlign: 'end' }}>
                    {this.state.wallet &&
                    <Button type="primary" style={{ marginRight: "20px", margintop: '10px', marginBottom: '20px' }} >
                        <span>Current Balance&nbsp;<b>{returnSymbol(this.state.wallet.balance/100,this.state.wallet.currency)}</b></span>
                    </Button>
                    }
                </p>
                <Table
                    bordered
                    dataSource={this.state.transactions}
                    columns={columns}
                    loading={this.state.loading}
                />
            </App>
        );
    }
}

export default withApollo(CPWallet);